import React from 'react';

import closeIcon from '../../../assets/img/close.svg';
import './styles.css';
import NewAssetForm from './NewAssetForm';

const NewAssetModal = ({ modalOpen, setModalOpen }) => {
  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <div className={`new-asset ${modalOpen && 'open'}`}>
      <div className="content-wrapper">
        <div className="new-asset-header">
          <span>UPLOAD</span>
          <img
            src={closeIcon}
            alt="close-modal"
            onClick={handleClose}
            style={{ maxHeight: '20px', maxWidth: '20px' }}
          />
        </div>
        <NewAssetForm onUploadComplete={handleClose} />
      </div>
    </div>
  );
};

export default NewAssetModal;
